module.exports = __webpack_public_path__ + "static/media/favicon.87fa317b.ico";